// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__103JJ","signatureBlock":"Footer_signatureBlock__3Evqt","signature":"Footer_signature__1UGRw"};